import React, { Component } from "react";
import { connect } from "react-redux";
import { config } from "../../_config/_config";
import logo from "../../images/firestorm_logo.png";
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from "react-bootstrap";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.setNavExpanded = this.setNavExpanded.bind(this);
  }
  setNavExpanded(expanded) {
    this.setState({ navExpanded: expanded });
  }
  render() {
    return (
      <div className="outer_application_form">
        <header id="header">
          <section className="header-top">
            <div className="wrapper">
              <div className="container">
                <a href={config.mainUrl} title="Firestorm" className="logo">
                  <img className="main_logo" src={logo} alt="Firestorm logo" />
                </a>
                <div className="contact-section">
                  <a
                    href={config.mainUrl + "/contact-us/"}
                    className="buttons "
                  >
                    Contact Us
                  </a>
                  <a href={config.mainUrl + "/about-us/"} className="buttons ">
                    About Us
                  </a>
                  <a
                    href={config.baseUrl + "login"}
                    className="icon-emplogin buttons"
                  >
                    Employee Login
                  </a>
                  <span className="tel">1-530-898-8153</span>
                </div>
              </div>
            </div>
          </section>

          <Navbar
            inverse={true}
            onToggle={this.setNavExpanded.bind(this)}
            expanded={this.state.navExpanded}
          >
            <Navbar.Header>
              {/* <Navbar.Brand>
                      <Link to={"/dashboard"}><img src={logo} alt="Firestorm"/></Link>
                    </Navbar.Brand> */}
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              {/* <Nav>     */}
              {/* <ul className="nav navbar-nav">
                      <li><NavLink strict to={config.mainUrl} activeClassName={"active"} onClick={this.closeNav.bind(this)}>Home</NavLink></li>
                      <li><NavLink to={config.mainUrl+"/forestry/"} activeClassName={"active"} onClick={this.closeNav.bind(this)}>Forestry</NavLink></li>
                       <li><NavLink to={config.mainUrl+"/fire-safety/"} activeClassName={"active"} onClick={this.closeNav.bind(this)}>Fire Safety</NavLink></li>
                       <li><NavLink to={config.mainUrl+"/emergency/"} activeClassName={"active"} onClick={this.closeNav.bind(this)}>Emergency</NavLink></li>
                       <li><NavLink to={config.mainUrl+"/training/"} activeClassName={"active"} onClick={this.closeNav.bind(this)}>Training</NavLink></li>
                       </ul> */}
              {/* </Nav> */}
              <ul className="nav navbar-nav">
                <li>
                  <a href={config.mainUrl}>Home</a>
                </li>
                <li>
                  <a href={config.mainUrl + "/forestry/"}>Forestry</a>
                </li>
                <li>
                  <a href={config.mainUrl + "/fire-safety/"}>Fire Safety</a>
                </li>
                <li>
                  <a href={config.mainUrl + "/emergency/"}>Emergency</a>
                </li>
                <li>
                  <a href={config.mainUrl + "/training/"}>Training</a>
                </li>
              </ul>
            </Navbar.Collapse>
          </Navbar>
        </header>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(Header);
export { connectedApp as Header };
